import React, { useEffect, useState } from "react";
import { client } from "../../sanity/client";
import BlogHero from "../../container/blogHero/BlogHero";
import BlogWrapper from "../../container/blogWrapper/BlogWrapper";
import { Helmet } from "react-helmet-async";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      const query = `*[_type == "post"] | order(publishedAt desc){
        _id,
        title,
        slug,
        coverImage,
        "authorName": author->name,
        "authorImage": author->image,
        description,
        publishedAt,
        "categories": categories[]->title,
      }`;

      try {
        const posts = await client.fetch(query);
        setBlogs(posts);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return (
      <section className="blogs">
        <article className="container flex">
          <div className="loading">
            <span className="spinner"></span>
          </div>
        </article>
      </section>
    );
  }

  // Separate the latest blog from the rest
  const [latestBlog, ...otherBlogs] = blogs;
  return (
    <>
      <Helmet>
        <title>Blogs - Radiksez</title>
        <meta
          name="description"
          content="Read our latest blogs on software development, quality assurance, social media management, and AI & ML validation."
        />
        <link rel="canonical" href="https://radiksez.com/blogs" />
      </Helmet>

      <main className="blogs">
        <BlogHero blogPost={latestBlog} />
        <BlogWrapper blogPosts={otherBlogs} />
      </main>
    </>
  );
};

export default Blogs;
